import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "custom-font-text" }
const _hoisted_2 = {
  class: "location-step",
  name: "location"
}
const _hoisted_3 = {
  class: "location-step",
  name: "workplace"
}
const _hoisted_4 = {
  "data-testid": "ls-input-workplace",
  class: "location-step-input"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value", "checked"]
const _hoisted_7 = { class: "step-input-label" }
const _hoisted_8 = ["value", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_location = _resolveComponent("input-location")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.location.title')), 1),
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.location.step1.subtitle')) + " ", 1),
      _createElementVNode("a", {
        class: "open-bottom-sheet",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openBottomSheet && _ctx.openBottomSheet(...args)))
      }, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.location.help')), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_input_location, {
        ref: "inputLocation",
        "default-address": _ctx.defaultLocation,
        class: "location-step-input",
        "data-testid": "ls-input-location",
        "blocked-countries-list": _ctx.blockedCountriesList,
        onFocus: _ctx.emitFocus,
        "onInputLocation:validated": _ctx.updateAddress,
        onInput: _ctx.validateAddress
      }, null, 8, ["default-address", "blocked-countries-list", "onFocus", "onInputLocation:validated", "onInput"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.location.step2.subtitle')) + " ", 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("joy-selectable-item-group", {
          value: _ctx.workPlacePreference,
          name: "workplaceList",
          "full-width": "",
          onJoySelectableItemGroupChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateWorkplace && _ctx.updateWorkplace(...args)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workplaces, (workplace) => {
            return (_openBlock(), _createElementBlock("joy-selectable-item", {
              key: workplace.value,
              value: workplace.value,
              checked: _ctx.isWorkplaceSelected(workplace.value),
              type: "outline"
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(workplace.label), 1)
            ], 8, _hoisted_6))
          }), 128))
        ], 40, _hoisted_5)
      ])
    ]),
    (_ctx.isStrategyFunnelMode() && _ctx.isWorkplaceOnSite())
      ? (_openBlock(), _createElementBlock("joy-checkbox", {
          key: 0,
          value: _ctx.willingnessToTravelInternationally,
          checked: _ctx.willingnessToTravelInternationally,
          "data-testid": "willingness-to-travel-internationally",
          class: "joy-mt-7",
          onValueChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleWillingnessToTravelInternationallyChange && _ctx.handleWillingnessToTravelInternationallyChange(...args)))
        }, _toDisplayString(_ctx.$msg('profile.edition.workplace.preferences.international.willingnessToTravel')), 41, _hoisted_8))
      : _createCommentVNode("", true)
  ]))
}